import React from 'react';
export function KeyDetailsStrip() {
  const stats = [{
    value: '485 sqm',
    label: 'TOTAL AREA'
  }, {
    value: '3',
    label: 'CAR PARKS'
  }, {
    value: '2',
    label: 'LEVELS'
  }, {
    value: 'PRE-MARKET',
    label: 'STATUS'
  }];
  return <section className="bg-brand-dark py-10 md:py-16 border-y border-brand-grey/20" data-id="element-42">
      <div className="max-w-7xl mx-auto px-5 md:px-12 lg:px-24" data-id="element-43">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-y-8 md:gap-y-10" data-id="element-44">
          {stats.map((stat, index) => {
          const isLastCol = index === stats.length - 1;
          const isLeftOnMobile = index % 2 === 0;
          return <div key={index} className={`flex flex-col items-center text-center ${isLeftOnMobile && !isLastCol ? 'border-r border-brand-grey/20' : ''} ${!isLastCol ? 'md:border-r md:border-brand-grey/20' : ''}`} data-id="element-45">
                <span className="font-display text-brand-gold text-2xl md:text-4xl uppercase mb-2 md:mb-3" data-id="element-46">
                  {stat.value}
                </span>
                <span className="font-mono text-brand-grey text-[10px] md:text-xs uppercase tracking-label" data-id="element-47">
                  {stat.label}
                </span>
              </div>;
        })}
        </div>
      </div>
    </section>;
}